define('lq/events/actions/pdfMergeCommand',[
    'lq/events/actions/eventAction',
    'lq'
], function (EventAction, lq) {
    'use strict';

    var PdfMergeCommand = function(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    };

    EventAction.extend(PdfMergeCommand, EventAction);

    PdfMergeCommand.typeName = 'PdfMergeCommand';

    PdfMergeCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PdfMergeCommand.prototype.createEventActionRequest = function () {
        var self = this;

        return {
            eventActionType: 'PdfMerge',
            command: self.eventData.command
        };
    };

    PdfMergeCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty) {
            this.handleExecutionTrailDirty(continuation);
        } else {
            if (eventActionResponse.download) {
                var url = lq.getTenantUrl(
                    'PdfMerge/?actionId=' + eventActionResponse.actionId +
                    '&pdfMergeId=' + eventActionResponse.pdfMergeId +
                    '&openInBrowser=false' +
                    '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters() || {})) +
                    '#toolbar=1');
                window.open(url);
            }
            continuation();
        }
    };

    return PdfMergeCommand;
});
